import { useContext, useEffect, useState } from "react";
import CartIcon from "../Cart/CartIcon";
import CartContext from "../store/cart-context";
import classes from "./HeaderCartButton.module.css";

const HeaderCartButton = (props) => {
  const [btnAnimation, setbtnAnimation] = useState(false);
  const cartCtx = useContext(CartContext);

  const { items } = cartCtx;

  const numberofCartItems = items.reduce((curNumber, item) => {
    return curNumber + item.amount;
  }, 0);

  //For the bump animation
  useEffect(() => {
    if (items.length === 0) {
      return;
    }
    setbtnAnimation(true);
    const timer = setTimeout(() => {
      setbtnAnimation(false);
    }, 300);

    return () => {
      clearTimeout(timer);
    };
  }, [items]);
  const btnClasses = `${classes.button} ${btnAnimation ? classes.bump : ""}`;
  //reduce allows us to transform the value in an array into a single value
  return (
    <button className={btnClasses} onClick={props.onClick}>
      <span className={classes.icon}>
        <CartIcon />
      </span>
      <span>Your Cart</span>
      <span className={classes.badge}>{numberofCartItems}</span>
    </button>
  );
};

export default HeaderCartButton;
